import "../../_namespaces.js";
import "./response.js";

window.AssessmentViewer ??= {};
window.AssessmentViewer.Views ??= {};

AssessmentViewer.Views.ResponseChoice = class ResponseChoice extends AssessmentViewer.Views.Response {
  constructor() {
    super(...arguments);
    this.initialize = this.initialize.bind(this);
    this.updateSelectedState = this.updateSelectedState.bind(this);
    this.findInput = this.findInput.bind(this);
  }

  initialize() {
    super.initialize();
    return this.listenTo(this.model, "change:selected", this.render);
  }

  // EVENT HANDLERS

  handleSelectedChange() {
    this.updateSelectedState();
    return this.render();
  }

  // HELPER METHODS

  updateSelectedState() {
    return this.model.set("selected", this.findInput().prop("checked"));
  }

  findInput() {
    return this.$el.find("input[name=selected]");
  }
};
AssessmentViewer.Views.ResponseChoice.prototype.events = { "change [name=selected]": "handleSelectedChange" };
